import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { FONT_FAMILY } from '../../theme';
import useInView from '../../hooks/useInView';

export default function Hero({ title, subtitle, image, ctaText = 'Visit Us', ctaHref = '/contact' }) {
    const [ref, inView] = useInView({ threshold: 0.05, once: true });

    return (
        <Box ref={ref} sx={{ position: 'relative', width: '100%', height: { xs: 480, md: '100vh' }, overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <img
                src={image}
                alt="Hero"
                style={{ width: '100%', height: '100%', objectFit: 'cover', filter: 'brightness(0.45) contrast(0.95)', transition: 'transform 0.6s', objectPosition: 'center' }}
            />
            <Box sx={{ position: 'absolute', inset: 0, zIndex: 2, display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', px: { xs: 3, md: 6 } }}>
                <Box sx={{ maxWidth: 920 }}>
                    <Typography
                        variant="h1"
                        sx={{ color: '#fff', fontWeight: 700, fontFamily: FONT_FAMILY, fontSize: { xs: '2rem', md: '3.2rem' }, mb: 2, textShadow: '0 10px 40px rgba(0,0,0,0.6)' }}
                        style={{
                            opacity: inView ? 1 : 0,
                            transform: inView ? 'translateY(0)' : 'translateY(12px)',
                            transition: 'opacity 800ms ease, transform 800ms ease'
                        }}
                    >{title}</Typography>
                    <Typography
                        variant="h5"
                        sx={{ color: '#fff', fontWeight: 400, mb: 4, maxWidth: 820, mx: 'auto', textShadow: '0 6px 24px rgba(0,0,0,0.45)' }}
                        style={{
                            opacity: inView ? 1 : 0,
                            transform: inView ? 'translateY(0)' : 'translateY(12px)',
                            transition: 'opacity 900ms ease 120ms, transform 900ms ease 120ms'
                        }}
                    >{subtitle}</Typography>
                    <Button
                        href={ctaHref}
                        variant="contained"
                        sx={{ bgcolor: '#ed5034', color: '#fff', borderRadius: 1, px: 4, py: 1.1, fontWeight: 600, '&:hover': { bgcolor: '#d64528' } }}
                        style={{
                            opacity: inView ? 1 : 0,
                            transform: inView ? 'translateY(0)' : 'translateY(12px)',
                            transition: 'opacity 900ms ease 220ms, transform 900ms ease 220ms'
                        }}
                    >{ctaText}</Button>
                </Box>
            </Box>
            <Box sx={{ position: 'absolute', inset: 0, bgcolor: 'linear-gradient(180deg, rgba(0,0,0,0.35), rgba(0,0,0,0.55))', zIndex: 1 }} />
        </Box>
    );
}
